module.exports = __webpack_public_path__ + "media/images/dummy-8c2cc139b82bf70903a9403f7dfcd71d.png";